import { CAccordionBody, CAccordionHeader, CAccordionItem } from "@coreui/react";
import clsx from "classnames";
import { useTranslation } from "react-i18next";
import style from "./Accordion.module.css";
import P from "layouts/wrapper/P";
import { useEffect, useRef } from "react";

function AccordionText(props) {
    const {t} = useTranslation();
    const { index, header, normal,  } = props;

    const policyRef = useRef(null);
    const swiperInstance = useRef(null);
    const scrollTimeout = useRef(null);

       // Swiper 인스턴스 가져오기
       useEffect(() => {
        swiperInstance.current = document.querySelector(".swiper")?.swiper;
    }, []);

    const smoothScroll = (target, delta) => {
        let start = target.scrollTop;
        let startTime = performance.now();
        let duration = 300; // 애니메이션 지속시간 (ms)

        const animate = (time) => {
            let elapsed = time - startTime;
            let progress = Math.min(elapsed / duration, 1); // 진행 정도 (0~1)
            let easedProgress = progress * (2 - progress); // Ease-out 효과

            target.scrollTop = start + delta * easedProgress;

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    };

    useEffect(() => {
        const el = policyRef.current;
        if (!el) return;

        const handleWheel = (e) => {
            const { scrollTop, scrollHeight, clientHeight } = el;
            const delta = e.deltaY;

            const isScrollingDown = delta > 0;
            const isScrollingUp = delta < 0;

            const canScrollDown = scrollTop + clientHeight < scrollHeight;
            const canScrollUp = scrollTop > 0;

            const shouldPrevent = (isScrollingDown && canScrollDown) || (isScrollingUp && canScrollUp);

            if (shouldPrevent) {
                e.preventDefault(); // 브라우저 기본 스크롤 막기
                e.stopPropagation(); // Swiper까지 전달 막기

                if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
                scrollTimeout.current = setTimeout(() => {
                    smoothScroll(el, delta);
                }, 10);
            } else {
                // 요소가 끝에 도달했으면 스크롤만 되고, Swiper는 계속 활성화됨
                // 여기에 swiper.mousewheel.enable() 넣을 수도 있음
            }
        };

        el.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            el.removeEventListener('wheel', handleWheel);
        };
    }, []);


    // const handleScroll = (e) => {
    //     if (policyRef.current) {
    //         const { scrollTop, scrollHeight, clientHeight } = policyRef.current;
    //         const isAtTop = scrollTop === 0;
    //         const isAtBottom = scrollTop + clientHeight === scrollHeight;

    //         if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
    //             e.preventDefault(); // Swiper에 이벤트 전달 방지
    //         } else {
    //             e.preventDefault(); // Swiper 이벤트 막기
                
    //             //  기존 `scrollTimeout`에 대한 잘못된 접근 해결
    //             if (scrollTimeout.current) clearTimeout(scrollTimeout.current); // 기존 애니메이션 제거
                
    //             scrollTimeout.current = setTimeout(() => {
    //                 smoothScroll(policyRef.current, e.deltaY);
    //             }, 10);
    //         }
    //     }
    // };


    const handleTouchStart = () => {
        if (window.innerWidth <= 768 && swiperInstance.current) {
            swiperInstance.current.allowTouchMove = false; // 모바일에서 Swiper 터치 이동 비활성화
        }
    };

    const handleTouchEnd = () => {
        if (window.innerWidth <= 768 && swiperInstance.current) {
            swiperInstance.current.allowTouchMove = true; // Swiper 터치 이동 다시 활성화
        }
    };

    const handleMouseEnter = () => {
        if (swiperInstance.current) {
            swiperInstance.current.mousewheel.disable(); // Swiper 마우스 휠 비활성화
        }
    };

    const handleMouseLeave = () => {
        if (swiperInstance.current) {
            swiperInstance.current.mousewheel.enable(); // Swiper 마우스 휠 다시 활성화
        }
    };

    return (
        <CAccordionItem itemKey={index ? index + 1 : 1} style={{width: "100%"}}>
            {/* <CAccordionHeader>{header}{props.choose && <P>{"("}{t("choose")}{")"}</P>}{props.accent && <P color={"var(--main-color)"}>{"("}{t("required")}{")"}</P>}</CAccordionHeader> */}
            <CAccordionBody style={props.style}>
                <div className={clsx(style.fixedScroll)} 
                    style={{ backgroundColor: "rgba(247,247,247,1)", height: props.height ? props.height : null, overflowY: props.overflowY ? props.overflowY : "scroll", borderRadius: "5px" }}
                    ref={policyRef}
                    // onWheel={handleScroll} // 마우스 휠 이벤트 차단
                    onTouchStart={handleTouchStart} // 모바일 터치 시 Swiper 슬라이드 막기
                    onTouchEnd={handleTouchEnd} // 터치 종료 시 Swiper 다시 활성화
                    onMouseEnter={handleMouseEnter} // Swiper 마우스 휠 비활성화
                    onMouseLeave={handleMouseLeave} // Swiper 마우스 휠 다시 활성화
                >
                    {props.children}
                </div>
            </CAccordionBody>
        </CAccordionItem>
    );
}

export default AccordionText;